<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ptnum"><a id="page_10"></a>P<span class="smallcaps">ART</span> I</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Part01.vue?1a9f7fb8